import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-order-detail-ship-station',
  templateUrl: './order-detail-ship-station.component.html',
  styleUrls: ['./order-detail-ship-station.component.scss'],
})
export class OrderDetailShipStationComponent implements OnInit {
@Input() order: any[];

  constructor(private modalCtrl: ModalController) {}
  ngOnInit(): void {
    
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  getStatusColor(status: string): string {
    switch(status.toLowerCase()) {
      case 'shipped': return 'success';
      case 'awaiting_shipment': return 'warning';
      case 'cancelled': return 'danger';
      default: return 'medium';
    }
  }

  getImageUrl(item: any): string {
    if (item.imageUrl) return item.imageUrl;
    return 'assets/images/no-image.svg'; // Add a fallback image
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

   get allItems() {
    const itemsMap = new Map();
    
    this.order.forEach(order => {
      order.items.forEach(item => {
        // Usamos el orderItemId como clave única
        if (!itemsMap.has(item.orderItemId)) {
          itemsMap.set(item.orderItemId, {
            ...item,
            orderNumber: order.orderNumber,
            orderDate: order.orderDate
          });
        }
      });
    });
    
    return Array.from(itemsMap.values());
  }

}
